module.exports = __webpack_public_path__ + "static/12-ddee66619534808e56001ab7d44e4e70.jpeg";